type LocationMap = { [location: string]: string };

const canadaProvinceByAbbr: LocationMap = {
    AB: 'Alberta',
    BC: 'British Columbia',
    MB: 'Manitoba',
    NB: 'New Brunswick',
    NL: 'Newfoundland and Labrador',
    NS: 'Nova Scotia',
    NT: 'Northwest Territories',
    NU: 'Nunavut',
    ON: 'Ontario',
    PE: 'Prince Edward Island',
    QC: 'Québec',
    SK: 'Saskatchewan',
    YT: 'Yukon',
};

const usStateByAbbr: LocationMap = {
    AL: 'Alabama',
    AK: 'Alaska',
    AZ: 'Arizona',
    AR: 'Arkansas',
    CA: 'California',
    CO: 'Colorado',
    CT: 'Connecticut',
    DE: 'Delaware',
    FL: 'Florida',
    GA: 'Georgia',
    HI: 'Hawaii',
    ID: 'Idaho',
    IL: 'Illinois',
    IN: 'Indiana',
    IA: 'Iowa',
    KS: 'Kansas',
    KY: 'Kentucky',
    LA: 'Louisiana',
    ME: 'Maine',
    MD: 'Maryland',
    MA: 'Massachusetts',
    MI: 'Michigan',
    MN: 'Minnesota',
    MS: 'Mississippi',
    MO: 'Missouri',
    MT: 'Montana',
    NE: 'Nebraska',
    NV: 'Nevada',
    NH: 'New Hampshire',
    NJ: 'New Jersey',
    NM: 'New Mexico',
    NY: 'New York',
    NC: 'North Carolina',
    ND: 'North Dakota',
    OH: 'Ohio',
    OK: 'Oklahoma',
    OR: 'Oregon',
    PA: 'Pennsylvania',
    RI: 'Rhode Island',
    SC: 'South Carolina',
    SD: 'South Dakota',
    TN: 'Tennessee',
    TX: 'Texas',
    UT: 'Utah',
    VT: 'Vermont',
    VA: 'Virginia',
    WA: 'Washington',
    WV: 'West Virginia',
    WI: 'Wisconsin',
    WY: 'Wyoming',
    DC: 'Washington, D.C.',
};

export const northAmericaLocationByAbbr: LocationMap = {
    ...usStateByAbbr,
    ...canadaProvinceByAbbr,
};

const locationMapByCountry: { [countryCode: string]: LocationMap } = {
    US: usStateByAbbr,
    CA: canadaProvinceByAbbr,
};

function normalizeCountryCode(countryCode?: string): string | undefined {
    return countryCode?.trim().toUpperCase();
}

function getLocationMap(location: string, countryCode?: string): LocationMap {
    const normalizedCountryCode = normalizeCountryCode(countryCode);

    if (normalizedCountryCode && locationMapByCountry[normalizedCountryCode]) {
        return locationMapByCountry[normalizedCountryCode];
    }

    if (canadaProvinceByAbbr[location]) {
        return canadaProvinceByAbbr;
    }

    return usStateByAbbr;
}

export function getLocationTitleByAbbr(location: string, countryCode?: string): string {
    const locationMap = getLocationMap(location, countryCode);
    return locationMap[location] || location;
}

function isCanadianLocationCode(location: string, countryCode?: string): boolean {
    const normalizedCountryCode = normalizeCountryCode(countryCode);

    if (normalizedCountryCode === 'CA') {
        return true;
    }

    if (normalizedCountryCode === 'US') {
        return false;
    }

    return !!canadaProvinceByAbbr[location];
}

export function getPromotionTableTitle(location: string, title = '', countryCode?: string): string {
    if (!title) {
        return isCanadianLocationCode(location, countryCode) ? 'Sportsbooks' : 'Offers';
    }
    return title;
}

function formatLocationItems(locations: { [key: string]: string }): Array<{ value: string; display: string }> {
    return Object.keys(locations).map(location => {
        return {
            value: location,
            display: locations[location],
        };
    });
}

export function getLocationItems(location: string, countryCode?: string): Array<{ value: string; display: string }> {
    return formatLocationItems(getLocationMap(location, countryCode));
}
